module.exports = "<a ui-sref=\"{{ $ctrl.destinationState }}\"\n    ><div><img src=\"/assets/images/flexUiExit.png\" />Zamknij</div></a\n>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/flex-ui/exit/flex-ui-exit.html
// module id = 555
// module chunks = 0